import React, { useEffect, useState, useRef } from "react";
import { DashboardSkeleton } from "@/Components/Loader/dashboardSkeleton";
import { Button } from "@/shadcnComponents/ui/button";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const host = import.meta.env.VITE_BACKEND_SERVER_URL;
const ERROR_CALLBACK_URL = "/influencer/apps";

export const PlatformCheck: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const [openRefresh, setOpenRefresh] = useState(false);

  // Use a ref to track if the effect has run
  const effectRan = useRef(false);
  const navigate = useNavigate();


  useEffect(() => {
    if (effectRan.current) return; // Prevent running twice

    const platform = params.get("platform");

    if (platform === 'youtube') {
      if (params.get("error")) {
        toast.error("Error during Youtube authentication");
        navigate(ERROR_CALLBACK_URL);
        return;
      }

      const saveYTToken = async () => {
        try {

          const res = await axios.get(`${host}/auth/youtube/success?access_token=${params.get("access_token")}&refresh_token=${params.get("refresh_token")}&expires_in=${params.get("expires_in")}&scope=${params.get("scope")}&token_type=${params.get("token_type")}`, {
            headers: { "jwtToken": localStorage.getItem("jwtToken") },
          });

          if (res?.data?.success) {
            navigate("/influencer/apps");
          } else {
            setOpenRefresh(true);
            console.log("Error while logging in");
            return;
          }
        } catch (error) {
          console.error("Error during Youtube authentication:", error);
          setOpenRefresh(true)
          return;
        }
      }

      saveYTToken();
    }

    if (platform === 'twitter') {
      if (params.get("error")) {
        toast.error("Error during Twitter authentication");
        navigate(ERROR_CALLBACK_URL);
        return;
      }

      const saveTwitterToken = async () => {
        try {
          const res = await axios.get(`${host}/auth/twitter/success?access_token=${params.get("access_token")}&refresh_token=${params.get("refresh_token")}&expires_in=${params.get("expires_in")}&scope=${params.get("scope")}&token_type=${params.get("token_type")}`, {
            headers: { "jwtToken": localStorage.getItem("jwtToken") },
          });

          if (res?.data?.success) {
            navigate("/influencer/apps");
          } else {
            setOpenRefresh(true);
            console.log("Error while logging in");
            return;
          }
        } catch (error) {
          console.error("Error during Twitter authentication:", error);
          setOpenRefresh(true)
          return;
        }
      }

      saveTwitterToken();
    }

    if (platform === 'instagram') {
      if (params.get("error")) {
        toast.error("Error during Instagram authentication");
        navigate(ERROR_CALLBACK_URL);
        return;
      }

      const saveInstagramToken = async () => {
        try {
          const res = await axios.get(`${host}/auth/instagram/success?access_token=${params.get("access_token")}&refresh_token=${params.get("refresh_token")}&expires_in=${params.get("expires_in")}`, {
            headers: { "jwtToken": localStorage.getItem("jwtToken") },
          });

          if (res?.data?.success) {
            navigate("/influencer/apps");
          } else {
            setOpenRefresh(true);
            console.log("Error while logging in");
            return;
          }
        } catch (error) {
          console.error("Error during Instagram authentication:", error);
          setOpenRefresh(true)
          return;
        }
      }

      saveInstagramToken();
    }

    effectRan.current = true;
  }, [params]); // Empty dependency array means it should run only once after the initial render.

  const handlerefresh = async () => {
    setOpenRefresh(false);
    window.location.reload();
  };

  return (
    <>
      {openRefresh && (
        <div className="w-screen h-screen fixed top-0 left-0 z-40 flex items-center justify-center bg-[#12121280]">
          <div className="flex flex-col p-5 gap-5 items-center justify-center text-center w-[400px] bg-[#F5F5F5] rounded-lg font-inter text-[#757575] text-[16px]">
            <p>
              <b>Platform Integration takes longer than usual</b>
            </p>
            <div className="flex justify-between items-center">
              <Button onClick={() => navigate(ERROR_CALLBACK_URL)} variant="secondary">Cancel</Button>
              <Button onClick={handlerefresh}>Try again</Button>
            </div>
          </div>
        </div>
      )}
      <DashboardSkeleton />
    </>
  );
};
